import React, { useState } from "react";

import Button from "components/buttonNew/button";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";

import PreviousCard from "../previousCard/previousCard";

import { BreakfastShort } from "../../types";
import { sortPreviousByYear } from "../../utils";

export const PAGE_SIZE = 8;

type PreviousListProps = {
  previous: BreakfastShort[];
};

const PreviousList = ({ previous }: PreviousListProps) => {
  const { track } = useMixpanelTracking();
  const [page, setPage] = useState(1);
  const previousByYear = sortPreviousByYear(previous, PAGE_SIZE * page);

  const handleShowMore = async () => {
    await track("Breakfast list show more previous", {
      "Click text": "See more",
      Page: page + 1,
    });
    setPage((page) => page + 1);
  };

  const handleShowLess = async () => {
    setPage(1);

    await track("Breakfast list show less previous", {
      "Click text": "See less",
    });
  };

  return (
    <div className={"flex flex-col gap-[30px]"}>
      <ul
        className={"flex flex-col gap-4"}
        aria-label={"Previous events grouped by year"}
      >
        {previousByYear.map(([yearKey, array]) => {
          return (
            <li key={yearKey} aria-label={`In ${yearKey}`}>
              <h4
                className={
                  "mb-[10px] font-bold text-[14px] leading-[130%] text-mono-40"
                }
              >
                in {yearKey}
              </h4>
              <ul className={"grid grid-cols-1 gap-4 lg:grid-cols-2"}>
                {array.map((item, index) => {
                  return (
                    <li key={item.id + index} aria-label={"Past event"}>
                      <PreviousCard event={item} />
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>

      {PAGE_SIZE * page < previous.length && (
        <div className={"flex w-full flex-row justify-center"}>
          <Button
            size={"small"}
            buttonType={"secondary"}
            onClick={handleShowMore}
          >
            See more
          </Button>
        </div>
      )}
      {PAGE_SIZE * page >= previous.length && previous.length > PAGE_SIZE && (
        <div className={"flex w-full flex-row justify-center"}>
          <Button
            size={"small"}
            buttonType={"secondary"}
            onClick={handleShowLess}
          >
            See less
          </Button>
        </div>
      )}
    </div>
  );
};

export default PreviousList;
